export default __webpack_public_path__ + "static/media/perder.a8aca327.png";